export default "__VITE_ASSET__DyEn$b6G__"